import UniversalModal from './ui/main/UniversalModal'

export default UniversalModal

export {
  DEFAULT as DEFAULT_COMPONENT,
  LIST,
  TITLE,
  TEXT,
  BUTTONS,
  REWARD,
  IMAGE,
  IMAGES,
  HEADER,
  CLOSE,
  USER_BILLET,
} from './constants/components'

export { DEFAULT as DEFAULT_WRAPPER } from './constants/wrappers'
